// Third party librarie
import Compressor from 'compressorjs';

export const imageCompressorMixins = {
	data() {
		return {
			quality: 0.6,
			maxWidth: 1960,
			maxHeight: 1960,
			ImageTypeList:['image/tiff','image/webp']
		}
	},
	methods: {
		async compressMultipleImages(files) {
			let compressImages = await Promise.all(
					files.map(async file => {
						return await this.compressImage(file);
				}));
				
			return compressImages;
		},
		async compressImage(file) {
			console.log('Original photo  ' + file.name + ' = ' + file.size);
			let compressedJS = null;
			if (file.size > 20000) {
				await new Promise((resolve, reject) => {
					new Compressor(file, {
						maxWidth: this.maxWidth,
						maxHeight: this.maxHeight,
						quality: this.quality,
						success: resolve,
						error: reject
					});
				}).then(result => {
					console.log('Compressed photo ' + result.name + ' = ' + result.size);
					compressedJS = new File([result], result.name, { type: result.type });
				}).catch((err) => {
					console.log('Compress error: ', err.message);
				});
			} else {
				console.log('No compression  ' + file.name + ' = ' + file.size);
				compressedJS = file;
			}

			return compressedJS;
		},

		async validateImageWithType(img, imageTypeList) {
			// if File doesn't exist means user cancelled file upload.
			if (!img) {
				return false;
			}

			// get size in binary format
			let size = Math.round(img.size / 1024);
			let errorMessage = '';
			let isValid = true;
			
			// check File Size if exceeds 5 MB
			if (size > 20000 && isValid) {
				errorMessage = 'File Size must not exceed 20 MB.';
				isValid = false;
			} 
			// check if File Type is an Image
			const imageType = imageTypeList.find((element) => element === img.type);
			const imageIsValid = !!imageType
			
			if ((!imageIsValid || !img.type.includes('image')) && isValid) {
				errorMessage = `${img.name} has unsupported File Format. `;
				isValid = false;
			}

			// check if broken image
			let url = window.URL || window.webkitURL;
            let image = new Image();
            image.src = url.createObjectURL(img);
			const isImageBodyValid  = await this.checkImageBody(image.src)
			if (!isImageBodyValid) {
				errorMessage = `${img.name} contains unsupported image format.`;
				isValid = isImageBodyValid;
			}

			if (!isValid) {
				this.showCustomErrorToast('Unable to upload file.', errorMessage);
			}
			
			return isValid;
		},
		
		async validateImage(img) {
			// if File doesn't exist means user cancelled file upload.
			if (!img) {
				return false;
			}
			// get size in binary format
			let size = Math.round(img.size / 1024);
			let errorMessage = '';
			let isValid = true;
			
			// check File Size if exceeds 5 MB
			if (size > 20000 && isValid) {
				errorMessage = 'File Size must not exceed 20 MB.';
				isValid = false;
			} 

			// check if File Type is an Image
			const imageType = this.ImageTypeList.find((element) => element === img.type);
			const imageIsInvalid = !!imageType
			
			if ((imageIsInvalid || !img.type.includes('image')) && isValid) {
				errorMessage = `${img.name} has unsupported File Format. `;
				isValid = false;
			}

			// check if broken image
			let url = window.URL || window.webkitURL;
            let image = new Image();
            image.src = url.createObjectURL(img);
			const isImageBodyValid  = await this.checkImageBody(image.src)
			if (!isImageBodyValid) {
				errorMessage = `${img.name} contains unsupported image format.`;
				isValid = isImageBodyValid;
			}
			
			if (!isValid) {
				this.showCustomErrorToast('Unable to upload file.', errorMessage);
			}

			return isValid;
		},
		
		async checkImageBody(url) {
			if (!url || typeof url !== 'string') return Promise.resolve(false);
			return new Promise((resolve) => {
			  const imgElement = new Image();
			  imgElement.addEventListener('load', () => resolve(true));
			  imgElement.addEventListener('error', () => resolve(false));
			  imgElement.src = url;
			});
		},

		validateMultipleImages(images) {
			let validatedImages = []
			const checker =  arr => arr.every(value => value === true)

			if (!images) {
				return false;
			}

			for (const image in images) {
				let valid = this.validateImage(images[image])
				validatedImages.push(valid)
			}
			
			let areImagesValid = checker(validatedImages)

			// if (!areImagesValid) {
			// 	this.showCustomErrorToast('Unable to upload files.');
			// }
			
			return true;
		}
		
	}
}